// extracted by mini-css-extract-plugin
export default {"chatDisplay":"AdminChatDisplay_chatDisplay__ZwnDb","deleteRevisionButton":"AdminChatDisplay_deleteRevisionButton__fDa1y"};